module.exports = __webpack_public_path__ + "img/jt.69354adf.png";